import React from 'react'
import { Router, Routes, Route, BrowserRouter } from 'react-router-dom'
import MyHomePage from './MyHomePage'
import ContactPage from './ContactPage'
import HistoryPage from './HistoryPage'
import VisionMission from './VisionMission'
import AboutUs from './AboutUs'
import DonationPage from './DonationPage'
import CoursePage from './CoursePage'
import PalliativeCareForm from './PalliativeCareForm'
import VolunteerForm from './VolunteerForm'
import BooksPage from './BooksPage'
import NewsletterPage from './NewsletterPage'
import VideoGalleryTwin from './VideoGalleryTwin'
import ImageGallery from './ImageGallery'
import TabsPage from './TabsPage'
import CentersPage from './CentersPage'
import PalliativeCareArticles from './PalliativeCareArticles'
import PalliativeCareBlog from './PalliativeCareBlog'
import ResearchPage from './ResearchPage'
import ServicesPage from './ServicesPage'
import ScrollToTop from './ScrollToTop'
import PdfViewer from './PdfViewer'
import CareerPage from './CareerPage'

const MyBasicRouter = () => {
  return (
    <div>
      <ScrollToTop/>
      <Routes>
            <Route path="/" element={<MyHomePage />} />
            <Route path="/contactus" element={<ContactPage />} />
            <Route path="/historypage" element={<HistoryPage />} />
            <Route path="/visionmission" element={<VisionMission />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/donationpage" element={<DonationPage />} />
            <Route path="/coursepage" element={<CoursePage />} />
            <Route path="/palliativecareform" element={<PalliativeCareForm />} />
            <Route path="/volunteerform" element={<VolunteerForm/>} />
            <Route path="/bookspage" element={<BooksPage/>} />
            <Route path="/newsletter" element={<NewsletterPage/>} />
            <Route path="/videogallery" element={<VideoGalleryTwin/>} />
            <Route path="/imagegallery" element={<ImageGallery/>} />
                     <Route path="/tabspage" element={<TabsPage/>} />
                     <Route path="/centerspage" element={<CentersPage/>} />
                      <Route path="/articles" element={<PalliativeCareArticles/>} />
                       <Route path="/blogs" element={<PalliativeCareBlog/>} />
                       <Route path="/research" element={<ResearchPage/>} />
                       <Route path="/services" element={<ServicesPage/>} />
                       <Route path="/careers" element={<CareerPage/>} />
                       <Route path="/courseapplication" element={<CoursePage />} />
                          
                          <Route path="/pdfviewer/:filename" element={<PdfViewer />} />

             </Routes> 
    </div>
  )
}

export default MyBasicRouter